import React, { useMemo } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate, Routes, Route, useLocation } from "react-router-dom";
import { AppBar, Box, Button, Tab, Tabs, Toolbar, Typography } from "@mui/material";
import Feeds from "../../pages/Feeds";
import Scheduling from "../../pages/Scheduling";
import AdminPanel from "../../pages/AdminPanel";
import LanguageSwitcher from "../Shared/LanguageSwitcher";
import { useTranslation } from "react-i18next"; // Importiere useTranslation

const MainTabs: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation(); // Initialisiere den Übersetzungs-Hook

  // Tabs-Konfiguration inkl. Admin (nur bei Admin-User)
  const tabConfig = useMemo(() => [
    { label: t("common.feeds"), path: "/feeds" },
    { label: t("common.scheduling"), path: "/scheduling" },
    ...(user?.role === "admin" ? [{ label: t("common.admin"), path: "/admin" }] : []),
  ], [user?.role, t]); // 't' als Abhängigkeit hinzufügen

  // Redirect root path to /feeds
  React.useEffect(() => {
    if (location.pathname === "/") {
      navigate("/feeds", { replace: true });
    }
  }, [location.pathname, navigate]);

  const handleTabChange = (_: any, newValue: string) => {
    navigate(newValue);
  };

  return (
    <Box>
      <AppBar position="static">
        <Toolbar sx={{ justifyContent: "space-between", alignItems: "center" }}>
          {/* Tabs mittig */}
          <Box sx={{ 
            position: "absolute", 
            left: "50%", 
            transform: "translateX(-50%)",
            display: "flex",
            alignItems: "center"
          }}>
            <Tabs
              value={tabConfig.find(tab => location.pathname.startsWith(tab.path))?.path || "/feeds"}
              onChange={handleTabChange}
              sx={{
                borderBottom: "none",
                minHeight: "64px",
              }}
            >
              {tabConfig.map((tab) => (
                <Tab 
                  key={tab.path} 
                  label={tab.label} 
                  value={tab.path}
                  sx={{
                    color: "#000000",
                    "&.Mui-selected": {
                      color: "#000000",
                      fontWeight: "bold",
                    },
                    "&:hover": {
                      backgroundColor: "rgba(0, 0, 0, 0.1)",
                    },
                  }}
                />
              ))}
            </Tabs>
          </Box>
          {/* Zusatzinformationen rechts */}
          <Box sx={{ display: "flex", alignItems: "center", ml: "auto" }}>
            <Typography variant="body1" sx={{ mr: 2, color: "#000000" }}>
              {user?.customerName} ({user?.username})
            </Typography>
            <LanguageSwitcher />
            <Button 
              onClick={logout}
              sx={{ 
                color: "#000000",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.1)",
                },
              }}
            >
              {t("common.logout")}
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
      <Box sx={{ p: 2 }}>
        <Routes>
          <Route path="/feeds" element={<Feeds />} />
          <Route path="/scheduling" element={<Scheduling />} />
          {user?.role === "admin" && <Route path="/admin" element={<AdminPanel />} />}
          <Route path="*" element={<Feeds />} />
        </Routes>
      </Box>
    </Box>
  );
};

export default MainTabs;